// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2rdhy","range":"MonthRangeSwitch_range__Z50fU","disabled":"MonthRangeSwitch_disabled__2B5PW"};